<div class="timeline-container" #timeline>
  @for (step of stepConfigurations; track step; let i = $index; let isLast = $last) {
    <div class="timeline-step">
      
      <div class="timeline-indicator-container">
        <div class="timeline-indicator"></div>
        @if (!isLast) {
          <div class="timeline-line"></div>
        }
      </div>
      
      <div class="timeline-content">
        <div class="step-header">
          @if (step.leftLabel) {
            <span class="step-left-label">{{ step.leftLabel }}</span>
          }
          <span class="step-title">{{ step.title }}</span>
          @if (step.subtitle) {
            <small class="step-subtitle">{{ step.subtitle }}</small>
          }
        </div>
        
        <div class="step-body">
          <ng-template
            [ngTemplateOutlet]="stepContent"
            [ngTemplateOutletContext]="{ data: step.data }">
          </ng-template>
        </div>
        
        @if (enableStepTransitionButtons) {
          <div class="step-navigation">
            @if (i > 0) {
              <button mat-button>Back</button>
            }
            <button mat-button (click)="goToNextStep()">Next</button>
          </div>
        }
      </div>
    </div>
  }
</div>